import styled from 'styled-components';
import { MdArrowBack, MdArrowForward } from 'react-icons/md';

const ScrollButtonBase = styled.button`
  position: absolute;
  top: 50%;
  z-index: 3;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 0;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;

  @media (hover: none) {
    display: none;
  }

  transition:
    opacity 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
`;

export const ScrollButtonLeft = styled(ScrollButtonBase)`
  left: 0;
  transform: translateY(-50%) translateX(-50%);
`;

export const ScrollButtonRight = styled(ScrollButtonBase)`
  right: 0;
  transform: translateY(-50%) translateX(50%);
`;

export const Wrapper = styled.div`
  position: relative;
  display: flex;

  &:hover ${ScrollButtonLeft}, &:hover ${ScrollButtonRight} {
    opacity: 1;
    pointer-events: auto;
  }

  .nav-tabs {
    width: 100%;
    flex-wrap: nowrap;
    justify-content: ${({ $align, $stretch }) => {
      if ($stretch) return 'space-between';
      return (
        { left: 'flex-start', center: 'safe center', right: 'flex-end' }[$align] ?? 'flex-start'
      );
    }};
    overflow-x: auto;
    text-align: ${({ $stretch }) => ($stretch ? 'center' : 'left')};
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .nav-item {
    margin: 0;
    ${({ $stretch }) => ($stretch ? 'flex: 1;' : '')}
  }

  .nav-link {
    white-space: nowrap;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-bottom: 0;
  }
`;

export const ArrowIconLeft = styled(MdArrowBack).attrs({
  size: '16px',
  color: '#333333',
})``;

export const ArrowIconRight = styled(MdArrowForward).attrs({
  size: '16px',
  color: '#333333',
})``;
